import type React from 'react';

import { Row } from 'enable-ui';

import {
  RowStyle,
  StepDot,
  StepLine,
  StepTitle,
  StepWrapper,
  StepperContainer,
} from 'modules/classes/styles/steper';

interface StepperProps {
  currentStep: number;
  steps: {
    title: string;
  }[];
}

const Stepper: React.FC<StepperProps> = ({ currentStep, steps }) => {
  return (
    <StepperContainer>
      {steps.map((step, index) => (
        <StepWrapper key={index}>
          <Row style={RowStyle}>
            <StepDot active={currentStep === index} completed={index < currentStep} />
            {index < steps.length - 1 && <StepLine completed={index < currentStep} />}
          </Row>

          <StepTitle active={currentStep === index} completed={index < currentStep}>
            {step.title}
          </StepTitle>
        </StepWrapper>
      ))}
    </StepperContainer>
  );
};

export default Stepper;
